/**
 * PageHeader · cabecera blanca compartida (Mockup D `d-tophead`).
 *
 * Se renderiza dentro del MAIN de cualquier `<AppShell>` o `<ProjectShell>`.
 * Sustituye al `<Header />` oscuro en todas las rutas internas (login y
 * reset siguen sin shell ni cabecera).
 *
 * Estructura:
 *   ┌──────────────────────────────────────────────────────────────┐
 *   │ eyebrow / breadcrumb                       [actions →]       │
 *   │ Título grande con tags inline                                │
 *   │ subtítulo opcional                                           │
 *   └──────────────────────────────────────────────────────────────┘
 *
 * Permite hijos como `actions` (botones, avatares, exports) y `tags` (versión,
 * fase). Si recibe `subtitle` lo muestra debajo del título.
 */

export default function PageHeader({
  eyebrow,
  breadcrumb,
  title,
  subtitle,
  tags,
  actions,
  className = "",
  testid,
}) {
  return (
    <section
      data-testid={testid || "page-header"}
      className={`border-b border-gb-paper bg-gb-surface ${className}`}
    >
      <div className="mx-auto flex max-w-[1480px] flex-col gap-3 px-6 py-6 sm:px-10 sm:py-7 md:flex-row md:items-end md:justify-between">
        <div className="min-w-0 flex-1">
          {eyebrow && (
            <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-gb-red">
              {eyebrow}
            </p>
          )}
          {breadcrumb && (
            <p className="text-[11px] uppercase tracking-[0.18em] text-gb-muted">
              {breadcrumb}
            </p>
          )}
          <div className="mt-1.5 flex flex-wrap items-baseline gap-3">
            <h1 className="gb-display text-3xl leading-tight sm:text-4xl md:text-[40px]"
                data-testid="page-header-title">
              {title}
            </h1>
            {tags}
          </div>
          {subtitle && (
            <p className="mt-1.5 text-[13px] text-gb-muted">{subtitle}</p>
          )}
        </div>
        {actions && (
          <div className="flex flex-wrap items-center gap-2" data-testid="page-header-actions">
            {actions}
          </div>
        )}
      </div>
    </section>
  );
}
